export enum MandatoryFieldsTypes {
	main_media = 'mainMedia',
}
